module.exports = __webpack_public_path__ + "static/media/btc_phone.d6797672.png";